import React from 'react';
import { Typography, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import UserForm from '../components/users/UserForm';
import { HomeOutlined, UserOutlined, PlusOutlined } from '@ant-design/icons';

const { Title } = Typography;

const UserCreate: React.FC = () => {
  return (
    <div className='p-6'>
      <div className='mb-6'>
        <Breadcrumb
          items={[
            {
              title: (
                <Link to='/admin/dashboard'>
                  <HomeOutlined /> Trang chủ
                </Link>
              ),
            },
            {
              title: (
                <Link to='/admin/users'>
                  <UserOutlined /> Người dùng
                </Link>
              ),
            },
            {
              title: (
                <span>
                  <PlusOutlined /> Thêm mới
                </span>
              ),
            },
          ]}
        />
      </div>

      <UserForm />
    </div>
  );
};

export default UserCreate;
